export const httpGet = (url: string) => {
    try {
        return fetch(url).then(res => res.json())
    } catch (error) {
        return "";
    }
}